module.exports = __webpack_public_path__ + "static/img/adamjee.f9965a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/adamjee.png
// module id = zpP1
// module chunks = 1